import { ReactNode } from 'react';
import { ProSidebar } from './ProSidebar';
import { RoleProvider } from '../lib/role';
import shellStyles from '../styles/shell.module.css';

interface ProShellProps {
  children: ReactNode;
}

export function ProShell({ children }: ProShellProps) {
  return (
    <RoleProvider>
      <div className={shellStyles.shell}>
        <div className={shellStyles.sidebarCol}>
          <ProSidebar />
        </div>
        <main className={shellStyles.mainCol}>{children}</main>
      </div>
    </RoleProvider>
  );
}
